import Bugsnag from '@bugsnag/js';
import { Crumb } from '@propertypal/shared/src/services/logging';

const EXCLUDE_TERMS = [
  'Network request failed',
  'Network Error',
  'timeout exceeded',
  'API error 404',
  'API error 400',
  'API error 429',
  'Missing auth token',
];

const checkExcludedTerms = (error: Error) => {
  let exclude = false;

  if (error && error.message) {
    EXCLUDE_TERMS.forEach((term) => {
      if (error.message.includes(term)) {
        exclude = true;
      }
    });
  }

  return exclude;
};

export const logCrumb = (crumb: Crumb) => {
  if (typeof window !== 'undefined') {
    Bugsnag.leaveBreadcrumb(crumb.message, crumb.metaData);
  }
};

export const logError = (error: Error) => {
  const shouldExclude = checkExcludedTerms(error);

  if (!shouldExclude) {
    Bugsnag.notify(error);
  }
};
